import React, { memo, useEffect, useState } from 'react';
import {
  Stack,
  Typography,
  Icon,
  Tabs,
  Tab,
  CircularProgress,
  Rating,
  Chip
} from 'investira.react.components';
import { validators } from 'investira.sdk';
import { AVALIACAO_DISCRIMINACOES } from '../../../enums';

const AvaliacoesEditSugestoes = memo(props => {
  const { activeQuestionId, activeAliasQuestionId } = props;

  const [tab, setTab] = useState(0);
  const [isFetching, setFecthing] = useState(true);

  const chipColor = (pPontos = 0) => {
    return pPontos < 1.8 ? 'error' : pPontos < 2.2 ? 'warning' : pPontos < 3 ? 'info' : 'primary';
  };

  const handleChangeTab = (pEvent, pNewValue) => {
    setTab(pNewValue);
  };

  useEffect(() => {
    setFecthing(true);
    setTimeout(() => {
      setFecthing(false);
    }, 500);
  }, [activeQuestionId]);

  const xDiscriminacoes = Object.values(AVALIACAO_DISCRIMINACOES)
    .filter(xDiscriminacao => xDiscriminacao.questao_id === Number(activeQuestionId))
    .sort((a, b) => a.id - b.id);

  const headerRender = pActiveAliasQuestionId => {
    return (
      <Stack>
        <Typography color="textSecondary" variant="caption">
          Apoio contextual
        </Typography>
        <Typography color="textPrimary" variant="h5">
          Questão {pActiveAliasQuestionId}
        </Typography>
      </Stack>
    );
  };

  if (isFetching) {
    return (
      <Stack gap={3}>
        {headerRender(activeAliasQuestionId)}
        <Stack gap={2} sx={{ minHeight: '200px', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack gap={2} mb={2}>
      {headerRender(activeAliasQuestionId)}
      <Stack gap={2} mb={1}>
        <Stack gap={2}>
          <Typography
            color="textSecondary"
            variant="caption"
            sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
            Discriminação
          </Typography>
          <Stack gap={1.5}>
            {xDiscriminacoes.length === 0 && (
              <Typography color="textSecondary" variant="caption">
                Nenhuma discriminação disponível para esta questão.
              </Typography>
            )}
            {xDiscriminacoes.map((xDiscriminacao, xIndex) => {
              const xIsRespostaGestor = xDiscriminacao.resposta_gestor === true;

              return (
                <Stack key={xDiscriminacao.id}>
                  <Stack
                    sx={{
                      border: '1px solid',
                      borderColor: xIsRespostaGestor ? 'warning.main' : 'secondary.main',
                      p: 2,
                      borderRadius: 2,
                      position: 'relative'
                    }}>
                    {xIsRespostaGestor && (
                      <Stack
                        direction="row"
                        gap={1}
                        sx={{
                          backgroundColor: 'secondary.darkness',
                          px: 1.5,
                          position: 'absolute',
                          top: '-10px',
                          right: '8px'
                        }}>
                        <Icon iconName="user_tie" color="warn" size={16} />
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
                          Resposta do gestor
                        </Typography>
                      </Stack>
                    )}
                    <Stack gap={1}>
                      <Typography
                        color="textPrimary"
                        variant="caption"
                        sx={{ fontWeight: xIsRespostaGestor ? 500 : 400 }}>
                        {xDiscriminacao.discriminacao}
                      </Typography>
                      <Stack
                        direction="row"
                        gap={2}
                        alignItems="center"
                        justifyContent="space-between">
                        <Rating
                          name={`read-only-${xDiscriminacao.id}`}
                          value={xIndex || 0}
                          max={xDiscriminacoes.length - 1}
                          readOnly
                          size="small"
                        />
                        {!validators.isNull(xDiscriminacao.pontos) && (
                          <Chip
                            size="small"
                            label={`${xDiscriminacao.pontos > 0 ? '+' : ''}${
                              xDiscriminacao.pontos
                            } ponto${Math.abs(xDiscriminacao.pontos) === 1 ? '' : 's'}`}
                            color={chipColor(xDiscriminacao.pontos)}
                            sx={{ width: 'fit-content' }}
                          />
                        )}
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      </Stack>
      {/* <Divider /> */}
      <Stack gap={1}>
        <Typography
          color="textSecondary"
          variant="caption"
          sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
          Evidências complementares
        </Typography>
        <Tabs value={tab} onChange={handleChangeTab}>
          <Tab label="GESTOR" />
          <Tab label="ANEXOS" />
          <Tab label="ANBIMA" />
          <Tab label="CVM" />
          <Tab label="BIZ" />
        </Tabs>
        <Stack>
          {tab === 0 && (
            <>
              <Stack my={1} gap={2}>
                <Stack direction="row" alignItens="center" justifyContent="space-between">
                  <Stack direction="row" alignItens="center" gap={1}>
                    <Icon iconName="user_tie" color="primary" size={18} />
                    <Typography color="textPrimary" variant="body2" sx={{ fontWeight: 600 }}>
                      Comentário do gestor
                    </Typography>
                  </Stack>
                </Stack>
                <Stack gap={1}>
                  <Typography color="textPrimary" variant="caption">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam aliquet, risus
                    nec facilisis tempor, neque mi tincidunt enim, non luctus dolor enim id sem.
                    Pellentesque consequat, nisi ac dignissim interdum, sem risus faucibus elit, et
                    euismod turpis purus sed elit. Quisque rutrum, diam vitae feugiat."
                  </Typography>
                </Stack>
              </Stack>
            </>
          )}

          {tab === 1 && (
            <>
              <Stack my={1} gap={2}>
                <Stack gap={1}>
                  <Typography color="textPrimary" variant="caption">
                    Anexo 1
                  </Typography>
                  <Typography color="textPrimary" variant="caption">
                    Anexo 2
                  </Typography>
                  <Typography color="textPrimary" variant="caption">
                    Anexo 3
                  </Typography>
                </Stack>
              </Stack>
            </>
          )}

          {tab === 2 && (
            <>
              <Stack my={1} gap={2}>
                <Stack direction="row" alignItens="center" justifyContent="space-between">
                  <Stack direction="row" alignItens="center" gap={1}>
                    <Icon iconName="earth" color="primary" size={18} />
                    <Typography color="textPrimary" variant="body2" sx={{ fontWeight: 600 }}>
                      ANBIMA DDQ
                    </Typography>
                  </Stack>
                </Stack>
                <Stack gap={1}>
                  <Typography color="textPrimary" variant="caption">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam aliquet, risus
                    nec facilisis tempor, neque mi tincidunt enim, non luctus dolor enim id sem.
                    Pellentesque consequat, nisi ac dignissim interdum, sem risus faucibus elit, et
                    euismod turpis purus sed elit. Quisque rutrum, diam vitae feugiat."
                  </Typography>
                </Stack>
              </Stack>
            </>
          )}

          {tab === 3 && (
            <>
              <Stack my={1} gap={2}>
                <Stack direction="row" alignItens="center" justifyContent="space-between">
                  <Stack direction="row" alignItens="center" gap={1}>
                    <Icon iconName="earth" color="primary" size={18} />
                    <Typography color="textPrimary" variant="body2" sx={{ fontWeight: 600 }}>
                      Informações da CVM
                    </Typography>
                  </Stack>
                </Stack>
                <Stack gap={1}>
                  <Typography color="textPrimary" variant="caption">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas neque nisl,
                    facilisis vel orci in, interdum egestas quam. Donec consequat pellentesque
                    libero at ullamcorper. Quisque in risus at ex semper tempus. Mauris condimentum
                    tellus id convallis feugiat. Quisque nunc sem, sodales posuere faucibus a,
                    sagittis in justo. Sed vitae auctor ligula, a fringilla augue. Nulla condimentum
                    nisi sed diam bibendum convallis. Vestibulum congue aliquet turpis. Aliquam
                    augue dolor, mollis vitae vehicula eget, pretium ac purus. Aenean aliquet magna
                    a ex dapibus vehicula. Etiam convallis, dolor vitae fringilla convallis, dolor
                    lectus pharetra lorem, nec pellentesque purus arcu vel magna. Donec in lectus
                    orci. Sed dignissim eros at ligula finibus, ut pulvinar tellus pellentesque.
                    Proin auctor iaculis vulputate. Ut a nunc vel tellus feugiat egestas sit amet
                    sit amet libero.
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="caption"
                    sx={{ wordBreak: 'break-all', whiteSpace: 'pre-line' }}>
                    Fonte:
                    https://cvmweb.cvm.gov.br/SWB/Sistemas/SCW/CPublica/FormRefAdmCart/ConsultaFormReferenciaAdmCarteiraPJ.aspx?PK_PARTIC=7092&COMPTC=2023
                  </Typography>
                </Stack>
              </Stack>
            </>
          )}

          {tab === 4 && (
            <>
              <Stack my={1} gap={2}>
                <Stack direction="row" alignItens="center" justifyContent="space-between">
                  <Stack direction="row" alignItens="center" gap={1}>
                    <Icon iconName="investira_icon" color="primary" size={18} />
                    <Typography color="textPrimary" variant="body2" sx={{ fontWeight: 600 }}>
                      Investira.biz
                    </Typography>
                  </Stack>
                </Stack>
                <Stack gap={1}>
                  <Typography color="textPrimary" variant="caption">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas neque nisl,
                    facilisis vel orci in, interdum egestas quam. Donec consequat pellentesque
                    libero at ullamcorper. Quisque in risus at ex semper tempus. Mauris condimentum
                    tellus id convallis feugiat. Quisque nunc sem, sodales posuere faucibus a,
                    sagittis in justo. Sed vitae auctor ligula, a fringilla augue. Nulla condimentum
                    nisi sed diam bibendum convallis. Vestibulum congue aliquet turpis. Aliquam
                    augue dolor, mollis vitae vehicula eget, pretium ac purus. Aenean aliquet magna
                    a ex dapibus vehicula. Etiam convallis, dolor vitae fringilla convallis, dolor
                    lectus pharetra lorem, nec pellentesque purus arcu vel magna. Donec in lectus
                    orci. Sed dignissim eros at ligula finibus, ut pulvinar tellus pellentesque.
                    Proin auctor iaculis vulputate. Ut a nunc vel tellus feugiat egestas sit amet
                    sit amet libero.
                    <br />
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="caption"
                    sx={{ wordBreak: 'break-all', whiteSpace: 'pre-line' }}>
                    Fonte: https://app.investira.biz/empresas/154947
                  </Typography>
                </Stack>
              </Stack>
            </>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
});

export default AvaliacoesEditSugestoes;
